import { useEffect } from 'react';
import { DEFAULT_TRACES_SAMPLE_RATE } from 'integrations/sentry/sampling/defaults';
import { parseSampling } from 'integrations/sentry/sampling/parseSampling';
import { clearCache, readCache, writeCache } from 'integrations/sentry/sampling/samplingCache';

import { init } from '@sentry/react';

interface SentrySamplingManagerProps {
  sampling: string | 'RESET' | undefined;
  client: ReturnType<typeof init>;
}

const NONE = 'NONE' as const;
const IS_DEV = process.env.NODE_ENV === 'development';

export const SentrySamplingManager = ({ sampling = NONE, client }: SentrySamplingManagerProps) => {
  useEffect(() => {
    const nextValue = parseSampling(sampling);
    const cache = readCache();
    // if Sampling value is provided and it is a number - update local storage and apply new sampling
    if (typeof nextValue === 'number' && nextValue !== cache?.value) {
      writeCache(nextValue);
      updateSentrySamplingRate(nextValue, client);
      // In case of "RESET" we clear local storage and defaulting sampling rate.
    } else if (sampling === 'RESET') {
      clearCache();
      updateSentrySamplingRate(DEFAULT_TRACES_SAMPLE_RATE, client);
    }
  }, [sampling, client]);

  return null;
};

function updateSentrySamplingRate(value: number, client: SentrySamplingManagerProps['client']) {
  const sentryOptions = client?.getOptions();
  if (IS_DEV || !sentryOptions) {
    return;
  }
  sentryOptions.tracesSampleRate = value;
}
